<template>
  <div>
    <b-field label="Shipping Account Nickname">
      <b-input v-model="form.nickname" size="is-medium" placeholder="e.g. My UPS Account" @input="announce" />
    </b-field>
    <b-field label="UPS Account Number">
      <b-input v-model="form.account_number" size="is-medium" @input="announce" />
    </b-field>
    <b-field label="Description">
      <b-input v-model="form.description" size="is-medium" @input="announce" />
    </b-field>
    <b-field label="Reference (Optional)">
      <b-input v-model="form.reference" size="is-medium" @input="announce" />
    </b-field>
  </div>
</template>

<script>
export default {
  data () {
    return {
      form: {
        nickname: null,
        account_number: null,
        description: null,
        reference: null
      }
    }
  },
  computed: {
    valid () {
      return !!(this.form.nickname && this.form.account_number && this.form.description)
    }
  },
  methods: {
    announce () {
      this.$emit('input', this.valid ? this.form : null)
    }
  }
}
</script>
